<template>
  <div>
    <q-card
      class="cursor-pointer dropdownYear"
      :style="`background-color: ${bg}`"
      flat
    >
      <div class="row items-center">
        <span class="label q-mr-xs text-white"> {{ label }} </span>
        <span class="title text-white q-mr-md">
          {{ formattedSelectedYear }}
        </span>
        <div>
          <q-icon name="mdi-chevron-down" color="white" style="font-size: 20px">
          </q-icon>
        </div>
      </div>
    </q-card>
    <template>
      <q-popup-proxy
        ref="yearProxy"
        transition-show="scale"
        transition-hide="scale"
        :breakpoint="0"
        v-model="yearDialog"
      >
        <q-date
          minimal
          v-model="selectedYear"
          default-view="Years"
          emit-immediately
          @input="checkCalendar"
        >
        </q-date>
      </q-popup-proxy>
    </template>
  </div>
</template>

<script>
  export default {
    data: () => ({
      selectedYear: new Date().getFullYear(),
      yearDialog: false,
    }),
    props: {
      initialYear: {
        type: String,
        default: null,
      },
      label: {
        type: String,
        default: "year",
      },
      bg: {
        type: String,
        default: "rgba(0, 0, 0, 0.27)",
      },
    },
    watch: {
      initialYear: function () {
        this.initYear();
      },
    },
    mounted() {
      this.initYear();
    },
    computed: {
      formattedSelectedYear() {
        if (typeof this.selectedYear === "string") {
          return this.selectedYear.split("/")[0];
        } else {
          return this.selectedYear;
        }
      },
    },
    methods: {
      initYear() {
        this.selectedYear = this.initialYear
          ? parseInt(this.initialYear)
          : this.selectedYear;
      },
      checkCalendar(val, reason, details) {
        if (reason === "year") {
          this.$emit("selectYear", val);
          this.$refs.yearProxy.hide();
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
  }
  .dropdownYear {
    border-radius: 5px;
    padding-top: 9px;
    padding-bottom: 9px;
    padding-left: 10px;
    padding-right: 10px;
  }

  .label {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
    color: white;
    margin-right: 10px;
  }
</style>

